import { ProfileContext } from '../../../contexts/ProfileContext';
import React, { useContext } from 'react';
import ZdarKidsProgressBar from './ZdarKidsProgressBar';

export default function ZdarKidsHeader() {
    const { availableGame } = useContext(ProfileContext);
    if (availableGame) {
        return (
            <div className="zdar-kids-header">
                <ZdarKidsProgressBar />
            </div>
        );
    }
    return <React.Fragment />;
}
